"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductGallery = void 0;
require("./ProductGallery.scss");
var lodash_1 = require("lodash");
var gallery_1 = require("../lib/gallery/gallery");
var util_1 = require("../lib/util");
var ProductImagesModal_1 = require("./ProductImagesModal");
var ProductGallery = /** @class */ (function () {
    function ProductGallery(xansProductImage, style, cafe24Prod, addonProd) {
        var _this = this;
        this.cafe24Prod = cafe24Prod;
        this.addonProd = addonProd;
        var dynamicColumns = function (itemLength) {
            return itemLength <= 1 ? 1 : 2;
        };
        this.gallery = new gallery_1.WkGallery({ element: util_1.htmlDiv('nsr-addon nsr-addon-product-gallery'), dynamicColumns: dynamicColumns, singleImageStyle: 'width: 70%; min-width: 550px;' });
        var elGallery = this.gallery.element;
        elGallery.style.position = style.position;
        elGallery.style.top = style.top;
        elGallery.style.right = style.right;
        elGallery.style.bottom = style.bottom;
        elGallery.style.left = style.left;
        elGallery.style.width = style.width;
        elGallery.style.float = style.float;
        elGallery.style.marginLeft = style.marginLeft;
        elGallery.style.marginRight = style.marginRight;
        elGallery.style.marginTop = style.marginTop;
        elGallery.style.marginBottom = style.marginBottom;
        elGallery.addEventListener('gallery-click', function (ev) { return _this.onClickGallery(ev.detail); });
        this.update(undefined);
        util_1.after(xansProductImage, elGallery);
    }
    ProductGallery.prototype.bindTo = function (xansProductOption) {
        var _this = this;
        var optContainer = xansProductOption.querySelector('.xans-product-option [option_title]');
        if (optContainer) {
            var optStyle = optContainer.tagName.toLowerCase();
            if (optStyle === 'select') {
                var select_1 = optContainer;
                var listener = function () {
                    var _a;
                    var val = (_a = select_1.options[select_1.selectedIndex]) === null || _a === void 0 ? void 0 : _a.value;
                    _this.update(val);
                };
                select_1.addEventListener('change', listener);
                listener(); // 현재 옵션 선택 상태를 갤러리에 반영하기 위해
            }
            else if (optStyle === 'ul') {
                var selectedValue_1 = undefined;
                document.querySelectorAll('li[option_value]').forEach(function (li) {
                    var val = li.getAttribute('option_value');
                    li.addEventListener('click', function () {
                        setTimeout(function () {
                            var selected = li.classList.contains('ec-product-selected');
                            _this.update(selected ? val : undefined);
                        }, 100);
                    });
                    if (li.classList.contains('ec-product-selected'))
                        selectedValue_1 = val;
                });
                this.update(selectedValue_1); // 현재 옵션 선택 상태를 갤러리에 반영하기 위해
            }
        }
    };
    ProductGallery.prototype.update = function (optValue) {
        if (this.gallery && this.addonProd && this.cafe24Prod) {
            var imgList = void 0;
            if (optValue) {
                var pOptions = this.cafe24Prod.options.options[0];
                var option_value = lodash_1.find(pOptions.option_value, { option_text: optValue });
                if (option_value === null || option_value === void 0 ? void 0 : option_value.option_text_alias)
                    optValue = option_value.option_text_alias;
                var colorOption = lodash_1.find(this.addonProd.color_options, { opt_value: optValue });
                imgList = colorOption === null || colorOption === void 0 ? void 0 : colorOption.img_list;
            }
            if (!imgList || !imgList.length)
                imgList = [this.cafe24Prod.detail_image];
            this.gallery.update(imgList);
        }
        else {
            console.warn('ProductGallery not prepared');
        }
    };
    ProductGallery.prototype.onClickGallery = function (target) {
        var imgList = lodash_1.reduce(this.addonProd.color_options, function (imgList, opt) {
            if (opt.img_list) {
                for (var _i = 0, _a = opt.img_list; _i < _a.length; _i++) {
                    var img = _a[_i];
                    if (!lodash_1.includes(imgList, img))
                        imgList.push(img);
                }
            }
            return imgList;
        }, []);
        if (imgList.length) {
            new ProductImagesModal_1.ProductImagesModal({
                title: this.cafe24Prod.product_name,
                images: imgList,
                defaultIndex: Math.max(imgList.indexOf(target.src), 0)
            }).show();
        }
    };
    return ProductGallery;
}());
exports.ProductGallery = ProductGallery;
